export { default } from './SimpleReviewQuotesCarousel.vue';
